import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import ReactGA from 'react-ga';
import { getPrevPath } from '../../utils/path';
import Layout from '../Layout';
import Menu from '../Menu';
import UtilityBar from '../UtilityBar';
import Footer from '../Footer';
import '../../assets/styles/main.styl';

if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize(process.env.REACT_APP_GA_ID);
}

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sectionTitles: {}
    };
  }

  UNSAFE_componentWillMount() {
    const { pages } = this.props.data;
    const { location, onMount } = this.props;
    onMount(this.getRoutePaths(pages), location.pathname);
    this.generateSectionTitles(pages);
  }

  componentDidMount() {
    this.savePageview();
  }

  UNSAFE_componentWillReceiveProps({
    farthestPath,
    location,
    paths,
    data,
    storeFarthestPath
  }) {
    if (data.pages !== this.props.data.pages) {
      this.generateSectionTitles(data.pages);
    }

    if (paths.includes(location.pathname)) {
      if (
        !farthestPath ||
        paths.indexOf(location.pathname) > paths.indexOf(farthestPath)
      ) {
        storeFarthestPath(location.pathname);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.savePageview();
    }
  }

  savePageview = () => {
    if (process.env.NODE_ENV === 'production') {
      ReactGA.pageview(this.props.location.pathname);
    }
  };

  /*
   * Generates an object with paths as keys, values are the section title that should be shown for that path
   */
  generateSectionTitles = pages => {
    const sectionTitles = {};
    pages.forEach(function(section) {
      if (section.path) {
        sectionTitles[section.path] = section.title;
      }

      if (section.children) {
        section.children.forEach(function(child, childIndex) {
          if (child.path) {
            sectionTitles[child.path] =
              section.title +
              ' (' +
              (childIndex + 1) +
              ' of ' +
              section.children.length +
              ')';
          }
        });
      }
    });

    this.setState({
      sectionTitles
    });
  };

  getRoutePaths = (pages, paths = []) => {
    pages.forEach((item, i) => {
      if ('path' in item) {
        paths.push(item.path);
      }
      if ('children' in item) {
        this.getRoutePaths(item.children, paths);
      }
    });

    return paths;
  };

  renderRoutes = (dataItems, routes = []) => {
    dataItems.forEach((item, i) => {
      if ('path' in item) {
        routes.push(
          <Route
            exact
            key={item.path}
            path={item.path}
            render={() => item.content}
          />
        );
      }
      if ('children' in item) {
        this.renderRoutes(item.children, routes);
      }
    });
    return routes;
  };

  render() {
    const {
      location,
      data: { pages, metaData }
    } = this.props;
    const { sectionTitles } = this.state;

    return (
      <Layout
        sidebar={
          <Menu
            data={pages}
            metaData={metaData}
            currentPage={location.pathname}
          />
        }
        main={
          <Switch>
            {this.renderRoutes(pages)}
            <Route render={() => <h1>404</h1>} />
          </Switch>
        }
        utility={
          <UtilityBar
            currentPage={location.pathname}
            prevPage={getPrevPath(
              this.props.paths,
              this.props.location.pathname
            )}
            sectionTitles={sectionTitles}
            progressBarImage={metaData.progressBarImage}
          />
        }
        footer={<Footer data={metaData.Footer} />}
      />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ../core/src/components/App/App.js